export const firebaseConfig = {
  "projectId": "studio-7958346055-bb28a",
  "appId": "1:203782617826:web:f8a721ca2cdfcd61103cbb",
  "apiKey": "AIzaSyA6T6SpnOYPhq78G9LIETJkiKsFU0zlhR8",
  "authDomain": "studio-7958346055-bb28a.firebaseapp.com",
  "measurementId": "",
  "messagingSenderId": "203782617826"
};
